import React from "react";
import { Link } from "react-router-dom";

const FAQS = [
  {
    q: "What is Crew Coin?",
    a: "Crew Coin is an employee incentive platform that enables restaurant managers to recognize positive behaviors with coins employees can redeem for meaningful rewards.",
  },
  {
    q: "How do employees earn coins?",
    a: "Managers define challenges and target behaviors—such as attendance, upselling, teamwork, speed, and more—and employees earn coins when goals are achieved.",
  },
  {
    q: "What rewards are in the rewards store?",
    a: "Managers choose which rewards to offer in the store, including gift cards, preferred shifts, PTO perks, team prizes, meals, and more.",
  },
  {
    q: "Who provides the rewards?",
    a: "When an employee redeems coins, the manager (admin) is responsible for fulfilling the selected reward.",
  },
  {
    q: "How long does setup take?",
    a: "Most teams can launch in minutes: download the app, create rewards, post challenges, and invite staff.",
  },
  {
    q: "Can I have more than one admin per account?",
    a: "Yes. After the initial admin account is created, admin privileges can be assigned to additional users in Settings.",
  },
  {
    q: "Can managers run team-wide and individual challenges?",
    a: "Yes. Managers can publish open challenges for the entire team or assign targeted challenges to specific employees.",
  },
  {
    q: "Do challenges expire?",
    a: "Yes. Managers can set optional expiration dates so outdated incentives no longer appear as active.",
  },
  {
    q: "How do I price reward items?",
    a: "Reward pricing is fully customizable. In general, awarding more coins for high-impact behaviors can increase team motivation.",
  },
  {
    q: "What is the budget feature for?",
    a: "The budget feature helps admins manage monthly incentive spend and remain aligned with company guidelines.",
  },
  {
    q: "How do I delete a user?",
    a: "Users can be deleted in the Settings tab within the app or in the Dashboard at crewcoin.app.",
  },
];

export default function FAQPage() {
  return (
    <div className="cc-legal-page">
      <div className="container cc-legal-container cc-faq-page-shell">
        <div className="cc-faq-page-header">
          <img src="img/crewcoinlogo.png" alt="Crew Coin" className="cc-faq-page-logo" />
          <p className="mb-4">Frequently asked questions.</p>
        </div>

        <div className="cc-faq-list">
          {FAQS.map((item) => (
            <details key={item.q} className="cc-faq-item">
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
        </div>

        <div className="cc-faq-page-actions">
          <Link to="/signup" className="btn btn-custom">Start free trial</Link>
        </div>
      </div>
    </div>
  );
}
